import { Combobox, FormHelp, TextButton } from '@zillow/constellation';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { Field, FieldProps } from 'formik';
import { IEditField } from './formTools';
import { EditFieldControls } from './EditFieldControls';
import { FlexGrowFormField } from './FlexGrowFormField';
import { useListRolesQuery } from '../../API/roles/RolesApi';
import { IRoleData } from '../../types/roles/IRole';

export const EditRoleDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => {
  const { data: roles = [] } = useListRolesQuery();
  const { role } = task;
  // Find the role label from the role name string
  const roleLabel = role ? roles.find((r) => r.name === role)?.label : undefined;
  return (
    <TextButton buttonType={'primary'} onClick={setIsEditing} disabled={!setIsEditing} fontType={'bodySmall'}>
      {roleLabel ?? 'No Role'}
    </TextButton>
  );
};

export const EditRoleField: React.FC<IEditField> = ({ submitOnChange, cancel }) => {
  const { data: roles = [] } = useListRolesQuery();
  const roleOptions = roles.map((role: IRoleData) => ({ label: role.label, value: role.name }));

  return (
    <EditFieldControls fieldName={'role'} cancel={cancel}>
      <Field name={'role'}>
        {({ field, form, meta }: FieldProps) => {
          const handleRoleChange = (option: string | string[], meta: any) => {
            const selectedRoleName = meta.option?.value || null;
            const initialRole = form.initialValues.role;
            // Set the role as a string (the role name)
            form.setFieldValue(field.name, selectedRoleName);

            // Only submit if the role has actually changed
            if (submitOnChange && selectedRoleName !== initialRole) {
              form.submitForm();
            }
          };

          return (
            <FlexGrowFormField
              error={!!(meta.touched && meta.error)}
              description={meta.touched && meta.error ? <FormHelp>{meta.error}</FormHelp> : undefined}
              required
              control={
                <Combobox
                  name={field.name}
                  data-test-id={`${field.name}-edit`}
                  required
                  placeholder="Select a Role..."
                  value={field.value ?? ''}
                  onChange={handleRoleChange}
                  onBlur={field.onBlur}
                  options={roleOptions}
                  showLabelForValue
                />
              }
            />
          );
        }}
      </Field>
    </EditFieldControls>
  );
};
